export const AdapterSetMultipleTimes = 'Host Item Adapter should be set only once';
export const TokenTypeNotSupportedForCaching = 'Token type is not supported for caching: {0}';
